import React from 'react';
import PropTypes from 'prop-types';
import { MemoryRouter, BrowserRouter, Route } from 'react-router-dom';
import HomeMunicipal from 'containers/municipal';

import PactometroSiNoContainer from 'components/pactometro-si-no';
import HomeMultiplyMunicipal from 'containers/home-municipal-multiply';
import HomeMunicipalDetail from 'containers/home-municipal-detail';
import HomeMultiplyRegional from 'containers/home-regional-multiply';
import ModuleGenerator from './containers/moduleGenerator';
import ButtonGenerator from './containers/moduleGenerator/buttonGenerator';

import Pactometro from './containers/pactometro/index';
import Bars from './containers/bars';
import SumaBloques from './containers/sumaBloques';
import RankingPactometro from './containers/rankingPactometro';
import RankingTable from './containers/rankingTable';

import Dashboard from './containers/dashboard';
import Backup from './containers/dashboard/backup';
import HomeRegional from './containers/regional';

const TVRoutes = React.lazy(() => import('./containers/tv/routes'));

const Router =
  window.parent !== window ||
    window.location.hostname === 'localhost' ||
    window.location.href.indexOf('tvmodules') !== -1 ||
    window.location.href.indexOf('generador') !== -1
    ? BrowserRouter
    : MemoryRouter;

const basename = process.env.PUBLIC_URL || '/';

const RouterApp = ({ entry }) => (
  <div className="_main">
    <Router basename={basename} initialEntries={[entry]}>
      <div>
        <Route
          exact
          //
          // http://localhost:3000/elecciones-2023-mun-auto/C108/0/2022/REGIONAL/1/arc/1/1/R01-R07/home-multiply-regional-resultados.html
          //
          path="/:country/:navigableMode/:year/:type/:electionNumber/:chartType/:showMasterBar/:allMap/:placesId/home-multiply-regional-resultados.html"
          component={HomeMultiplyRegional}
        />
        <Route
          exact
          // http://localhost:3000/elecciones-2023-mun-auto/C108/0/2022/REGIONAL/1/arc/1/1/R01/home-regionales-resultados.html
          //
          path="/:country/:navigableMode/:year/:type/:electionNumber/:chartType/:showMasterBar/:allMap/:community?/:province?/:town?/home-regionales-resultados.html"
          component={HomeRegional}
        />

        <Route
          exact
          //
          // http://localhost:3000/elecciones-2023-mun-auto/C108/0/2019/MUNICIPAL/1/arc/1/28079-28050/home-multiply-municipales-resultados.html
          //
          path="/:country/:navigableMode/:year/:type/:electionNumber/:chartType/:showMasterBar/:placesId/home-multiply-municipales-resultados.html"
          component={HomeMultiplyMunicipal}
        />
        <Route
          exact
          //

          //
          // http://localhost:3000/elecciones-2023-mun-auto/C108/0/2019/MUNICIPAL/1/arc/1/28079/home-municipales-resultados.html
          //
          path="/:country/:navigableMode/:year/:type/:electionNumber/:chartType/:showMasterBar/:placeId?/home-municipales-resultados.html"
          component={HomeMunicipal}
        />
        <Route
          exact
          //

          //
          // http://localhost:3000/elecciones-2023-mun-auto/C108/0/2019/MUNICIPAL/1/1/home-municipales-detalle-resultados.html
          //
          path="/:country/:navigableMode/:year/:type/:electionNumber/:showMasterBar/home-municipales-detalle-resultados.html"
          component={HomeMunicipalDetail}
        />
        <Route
          exact
          //
          // http://localhost:3000/elecciones-2023-mun-auto/C108/0/2019/MUNICIPAL/1/arc/1/R13/28/28079/detalle-municipales-resultados.html
          //
          path="/:country/:navigableMode/:year/:type/:electionNumber/:chartType/:showMasterBar/:community?/:province?/:town?/detalle-municipales-resultados.html"
          component={HomeMunicipal}
        />
        <Route
          exact
          //
          // http://localhost:3000/elecciones-2023-mun-auto/0/2022/REGIONAL/1/1/R01/pactos-si-no.html
          //
          path="/:navigableMode/:year/:type/:electionNumber/:showMasterBar/:placeId?/pactos-si-no.html"
          component={PactometroSiNoContainer}
        />
        {/* http://localhost:3000/elecciones-2023-mun-auto/R01/0/2022/REGIONAL/1/R01/sumaBloques.html */}
        <Route
          exact
          path="/:navigableMode/:year/:type/:electionNumber/:showMasterBar/:placeId/sumaBloques.html"
          component={SumaBloques}
        />
        {/* http://localhost:3000/elecciones-2023-mun-auto/0/2019/MUNICIPAL/1/1/28079/pactometro.html */}
        <Route
          exact
          path="/:navigableMode/:year/:type/:electionNumber/:showMasterBar/:placeId/pactometro.html"
          component={Pactometro}
        />
        {/* http://localhost:3000/elecciones-2023-mun-auto/0/2019/MUNICIPAL/1/1/28079/bars.html */}
        <Route
          exact
          path="/:navigableMode/:year/:type/:electionNumber/:showMasterBar/:placeId/bars.html"
          component={Bars}
        />
        {/* http://localhost:3000/elecciones-2023-mun-auto/0/2022/REGIONAL/1/1/R01/rankingPactometro.html */}
        <Route
          exact
          path="/:navigableMode/:year/:type/:electionNumber/:showMasterBar/:placeId/rankingPactometro.html"
          component={RankingPactometro}
        />
        {/* http://localhost:3000/elecciones-2023-mun-auto/0/2022/REGIONAL/1/1/R01/rankingTable.html */}
        <Route
          exact
          path="/:navigableMode/:year/:type/:electionNumber/:showMasterBar/:placeId/rankingTable.html"
          component={RankingTable}
        />
        <React.Suspense fallback={<></>}>
          {process.env.REACT_APP_TV === 'true' && <TVRoutes />}
        </React.Suspense>
        <Route
          exact
          path="/test.html"
          component={() => (
            <ButtonGenerator
              electionType="REGIONAL"
              year="2022"
              electionNumber={1}
              location={{
                typePlace: 'REGION',
                ineId: 'R12'
              }}
            />
          )}
        />
        <Route exact path="/tvmodules/dashboard.html" component={Dashboard} />
        <Route exact path="/tvmodules/backup.html" component={Backup} />
        <Route
          exact
          path="/generador.html"
          component={() => <ModuleGenerator />}
        />
      </div>
    </Router>
  </div>
);

RouterApp.propTypes = {
  entry: PropTypes.string.isRequired
};

export default RouterApp;
